module.exports = __webpack_public_path__ + "img/map-1-star.498956bd.svg";